__turbopack_context__.v({
  "number": "index-module-scss-module__0Ir9Xq__number",
  "phoneButton": "index-module-scss-module__0Ir9Xq__phoneButton",
});
